import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { images } from '../../Constants/ImageUrls';
import { getUserIsLoggedIn } from '../../Utils/helper';
import { navigateToLoginPage } from '../../Utils/redirections';
import { LoginSection } from '../HomePage/NewHeader/MainHeader/styled';
import LoginPopupContainer from './LoginPopupContainer';
import Logout from './Logout';
import { showNewLogin } from './NewLoginModule/common';
import { fireLoginEvent, loginSuccessMethod } from './utils';

function LoginDesktop(props) {
  const { setCartItems, loginPopUp, setLoginPopUp } = props;
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const [userDetails, setUserDetails] = useState();
  const [desktopLogin, setDesktopLogin] = useState(false);

  useEffect(() => {
    if (Cookies.get('react_user_properties')) {
      setUserDetails(JSON.parse(Cookies.get('react_user_properties')));
    }
  }, []);

  useEffect(() => {
    if (loginPopUp) {
      setDesktopLogin(true);
      setShowLoginPopup(true);
      localStorage.setItem('redirectRoute', window.location.pathname);
    }
  }, [loginPopUp]);

  const showLogin = () => {
    if (getUserIsLoggedIn() && userDetails?.profile_image) {
      return (
        <>
          <img
            style={{ width: '48px', height: '48px' }}
            src={userDetails?.profile_image}
            alt=""
          />
          <p className="iconsText">Logout</p>
        </>
      );
    } else {
      return (
        <>
          {/* <img src="/images/loginnew.svg" alt="" /> */}
          <img src={images.loginIcon} alt="login" title="login" />
          <p className="iconsText">Profile</p>
          {/* <span>Login</span> */}
        </>
      );
    }
  };
  const handleLoginLogout = () => {
    fireLoginEvent('clicked_profile_menu_item');
    let isUserLoggedIn = getUserIsLoggedIn();
    if (isUserLoggedIn && userDetails?.profile_image) {
      setShowLogout(!showLogout);
    } else {
      fireLoginEvent('viewed_web_login');
      if (showNewLogin()) {
        setDesktopLogin(true);
        localStorage.setItem('redirectRoute', window.location.pathname);
        // navigateToLoginPage();
      } else setShowLoginPopup(!showLoginPopup);
      // setShowLoginPopup(!showLoginPopup);
    }
  };
  const handleLogout = () => {
    __KP_LOGIN_SDK_INSTANCE__.handleKPLogout();
    sessionStorage.setItem('kwikpass_sso_tooltip', 'false');
    Cookies.remove('token', '/');
    //Cookies.remove("web_user_id_react", "/");
    Cookies.remove('cart_items', '/');
    if (setCartItems) setCartItems([]);
    setShowLogout(false);
  };
  const closeModal = () => {
    setShowLoginPopup(false);
    setDesktopLogin(false);
    setLoginPopUp(false);
  };
  const handleSuccess = async () => {
    const loginSuccess = await loginSuccessMethod();
    window.location.reload();
  };

  return (
    <>
      <LoginSection className="desktopLogin" onClick={handleLoginLogout}>
        <div className="loginButton">{showLogin()}</div>
      </LoginSection>
      <Logout showButton={showLogout} handleLogout={handleLogout} />
      <LoginPopupContainer
        closeModal={closeModal}
        showLoginPopup={showLoginPopup}
        handleSuccess={handleSuccess}
        setShowLoginPopup={setShowLoginPopup}
        desktopLogin={desktopLogin}
      />
    </>
  );
}

export default LoginDesktop;
